import { Component } from '@angular/core';

@Component({
  selector: 'app-lineas-atencion',
  templateUrl: './lineas-atencion.component.html',
  styleUrls: ['./lineas-atencion.component.scss'],
  standalone: false,
})
export class LineasAtencionComponent {}
